<template>
  <div class="product">
    <div class="container">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">{{$t('navigation.home')}}</el-breadcrumb-item>
        <el-breadcrumb-item>POP{{productType}} {{$t('course.series')}} {{ productInfo.title }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="go-back" >
        <img @click="goBack" src="@/assets/icons/left.svg" alt="">
        <span @click="goBack">{{$t('product.backToList')}}</span>
      </div>
      <div class="product-title">
        <span>POP{{productType}}</span>
        <i></i>
        {{ productInfo.title }}
      </div>
      <Tabs :tabs="tabs" v-model="activeName"></Tabs>
      <component :productType="productType" :is="activeName === 'first' ? 'Details' : activeName === 'second' ? 'Install' : 'Replace'" :productInfo="productInfo"></component>
    </div>
  </div>
</template>

<script>
import Details from './components/Details.vue'
import Install from './components/Install.vue'
import Replace from './components/Replace.vue'
import { productListCn, productListEn } from '@/utils/util.js'
import Tabs from '@/components/Tabs.vue'

export default {
  components: {
    Details,
    Install,
    Replace,
    Tabs,
  },
  data() {
    return {
      activeName: 'first',
      productId: this.$route.params.productId || (JSON.parse(localStorage.getItem('productInfo'))||{}).productId,
      language: 'cn',
      productType: this.$route.params.productType || (JSON.parse(localStorage.getItem('productInfo'))||{}).productType,
    };
  },
  computed: {
    tabs() {
      const list = [
        {
          id: 'first',
          title: this.$t('product.productDesc')
        },
        {
          id: 'second',
          title: this.$t('product.installDesc')
        },
        {
          id: 'third',
          title: this.$t('product.replaceDesc')  
        },
      ]
      return this.productId === '6' ? list.slice(0, 2) : list
    },
    productInfo() {
      return (this.$i18n.locale === 'zh' ? productListCn : productListEn).find((item) => item.id === this.productId) || {};
    }
  },
  created() {
    if (!this.productId) {
      this.$router.push({ path: '/' });
    }
  },
  methods: {
    goBack() {
      this.$router.push({ path: '/' });
    }
  }
}
</script>

<style lang='scss' scoped>
.product {
  padding-top: 32px;
  .product-title {
    font-size: 24px;
    font-weight: 500;
    line-height: 29px;
    margin-bottom: 48px;
    color: #0A0A0A;
    display: flex;
    align-items: center;
    span {
      font-size: 16px;
      line-height: 21px;
      color: #0A0A0A;
      border: 1px solid #000;
      border-radius: 2px;
      padding: 4px 8px;
    }
    i {
      display: inline-block;
      width: 1px;
      height: 18px;
      background: #000;
      margin: 0px 8px;
    }
  }
  .el-tabs {
    margin-top: 48px;
  }
}




@media screen and (max-width: 850px) {
  .product {
    padding-top: 24px;
    .product-title {
      margin-bottom: 32px;
    }
  }
  .el-tabs {
    margin-top: 32px;
  }
}
</style>